import { cssTransition, ToastContainer } from "react-toastify";
import { useMediaQuery } from "../../hooks";
import { useTranslation } from "../../i18n";
import { cn } from "../../utils";
import "./index.css";
import type { ToastProviderProps } from "./types";

const slideRightTransition = cssTransition({
  enter: "aurem-toast-slide-right-in",
  exit: "aurem-toast-slide-right-out",
  appendPosition: false,
  collapseDuration: 300,
});

const slideLeftTransition = cssTransition({
  enter: "aurem-toast-slide-left-in",
  exit: "aurem-toast-slide-left-out",
  appendPosition: false,
  collapseDuration: 300,
});

const slideTopTransition = cssTransition({
  enter: "aurem-toast-slide-top-in",
  exit: "aurem-toast-slide-top-out",
  appendPosition: false,
  collapseDuration: 0,
});

export const ToastProvider = (props: ToastProviderProps) => {
  const isMobile = useMediaQuery("(max-width: 639px)");
  const { rtl } = useTranslation();
  const position = isMobile ? "top-center" : rtl ? "top-left" : "top-right";

  const transition = isMobile
    ? slideTopTransition
    : rtl
      ? slideLeftTransition
      : slideRightTransition;

  return (
    <ToastContainer
      rtl={rtl}
      autoClose={8000}
      closeButton={false}
      closeOnClick={false}
      draggable={false}
      hideProgressBar={true}
      icon={false}
      pauseOnHover={true}
      position={position}
      transition={transition}
      toastClassName={cn(
        "relative p-0 rounded-lg shadow-lg !min-h-0 w-[380px] border border-neutral-500/10",
        "focus-visible:outline focus-visible:outline-primary-500 focus-visible:border-primary-500",
        "mb-3",
      )}
      {...props}
    />
  );
};
